import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Collapse, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { InstallationFormModel } from 'src/Libs/flow/installation/forms'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { TabButtonGroup, Toggle } from 'src/Libs/inputs/react-hook-form'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

type WeatherForecastOptimizationOption =
  InstallationFormModel['storageSystem']['generalSettings']['advancedSettings']['weatherForecastOptimization']['weatherOptimizationOption']
const option1: WeatherForecastOptimizationOption = 'Storage batteries'
const option2: WeatherForecastOptimizationOption = 'Heat pump via SG-Ready'

export const WeatherForecastOptimization: React.FC = () => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))

  const { control } = useInstallationForm()
  const useWeatherForecastBasedCharging = useWatch({
    control,
    name: 'storageSystem.generalSettings.advancedSettings.weatherForecastOptimization.useWeatherForecastBasedCharging',
  })
  const weatherOptimizationOption = useWatch({
    control,
    name: 'storageSystem.generalSettings.advancedSettings.weatherForecastOptimization.weatherOptimizationOption',
  })

  return (
    <Box component={'section'}>
      <SettingsBox
        title={t('installation.storageEditor.weather-optimization-title')}
        description={t('installation.storageEditor.weather-optimization-description')}
        suffix={
          <Box
            sx={{
              display: {
                xs: 'flex',
                md: 'block',
              },
              justifyContent: 'flex-start',
              width: {
                xs: '100%',
                md: 'auto',
              },
            }}
          >
            <Toggle
              name="storageSystem.generalSettings.advancedSettings.weatherForecastOptimization.useWeatherForecastBasedCharging"
              label={
                useWeatherForecastBasedCharging
                  ? t('installation.storageEditor.weatherForecast')
                  : t('installation.storageEditor.weather-optimization-deactivated')
              }
              disabled={!canEdit}
            />
          </Box>
        }
      >
        <Collapse in={useWeatherForecastBasedCharging}>
          <SettingsBox
            title={t(
              weatherOptimizationOption === 'Storage batteries'
                ? 'installation.storageEditor.options.storage-batteries-description'
                : 'installation.storageEditor.options.heatpump-description'
            )}
            suffix={
              <TabButtonGroup
                name="storageSystem.generalSettings.advancedSettings.weatherForecastOptimization.weatherOptimizationOption"
                options={[
                  {
                    label: upMd
                      ? t('installation.storageEditor.options.storage-batteries')
                      : t('installation.storageEditor.options.storage-batteries-short'),
                    value: option1,
                  },
                  {
                    label: upMd ? t('installation.storageEditor.options.heatpump') : t('installation.storageEditor.options.heatpump-short'),
                    value: option2,
                  },
                ]}
                disabled={!canEdit}
              />
            }
            depth={1}
          />
        </Collapse>
      </SettingsBox>
    </Box>
  )
}
